import mailingOrderService from './services/mailing-order.service';

export const MAILING_ORDER_LIST = 'mailingOrder/MAILING_ORDER_LIST';
export const CREATE_MAILING_ORDER = 'mailingOrder/CREATE_MAILING_ORDER';
export const DELETE_MAILING_ORDER = 'mailingOrder/DELETE_MAILING_ORDER';
export const GENERATE_MAILING_ORDER = 'mailingOrder/GENERATE_MAILING_ORDER';

const initialState = {
  orders: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MAILING_ORDER_LIST: {
      const orders = action.payload;

      return {
        ...state,
        orders,
      };
    }
    case CREATE_MAILING_ORDER: {
      const order = action.payload;
      let orders = state.orders;

      orders = orders.concat([order]);

      return {
        ...state,
        orders,
      };
    }
    case DELETE_MAILING_ORDER: {
      const orderId = action.payload;
      let orders = state.orders;
      const index = orders.findIndex(({ id }) => id === orderId);

      if (index > -1) {
        orders.splice(index, 1);
        orders = orders.slice();
      }

      return {
        ...state,
        orders,
      };
    }
    case GENERATE_MAILING_ORDER: {
      const orderId = action.payload;
      let orders = state.orders;

      return {
        ...state,
        orders,
      };
    }
    default:
      return state
  }
}

export const loadMailingOrdersList = () => {
  return (dispatch, getState) => {
    return mailingOrderService.getMailingOrders()
      .then((list) => {
        dispatch({
          type: MAILING_ORDER_LIST,
          payload: list
        });

        return list;
      });
  };
};

export const createMailingOrder = (orderData) => {
  return (dispatch, getState) => {

    return mailingOrderService.createMailingOrder(orderData)
      .then((createdOrder) => {
        dispatch({
          type: CREATE_MAILING_ORDER,
          payload: createdOrder
        });

        return createdOrder;
      });
  };
};

export const deleteMailingOrder = (orderData) => {
  return (dispatch, getState) => {

    return mailingOrderService.deleteMailingOrder(orderData.id)
      .then(() => {
        dispatch({
          type: DELETE_MAILING_ORDER,
          payload: orderData.id
        });

        return orderData;
      });
  };
};

export const generateMailingOrder = (orderData) => {
  return (dispatch, getState) => {

    return mailingOrderService.generateMailingOrder(orderData.id)
      .then(() => {
        dispatch({
          type: GENERATE_MAILING_ORDER,
          payload: orderData.id
        });

        return orderData;
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/mailing-order.js